module.exports = __webpack_public_path__ + "static/media/guest_white.1d8babd6.svg";